// EmptyState — placeholder visual pra listas vazias.

interface EmptyStateProps {
  title: string;
  message?: string;
  action?: React.ReactNode;
}

export const EmptyState = ({ title, message, action }: EmptyStateProps) => {
  return (
    <div className="rounded-xl border border-dashed border-slate-300 p-10 text-center">
      <h3 className="text-base font-medium text-slate-700">{title}</h3>
      {message && <p className="mt-2 text-sm text-slate-500">{message}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
};
